<template>
  <eg-modal
    id="lms-import-errors-modal"
    :title="$t('essays.someNotImported')"
    :closable="true"
    :value="true"
    size="large"
    style="z-index: var(--layout-z-index-modal)"
    show-backdrop
    @close="onClose"
  >
    <div class="errors-content">
      <p class="mb-3">{{ $t("essays.couldNotImport") }}</p>

      <div class="errors-table-wrapper">
        <eg-b-table
          :items="submissions"
          :fields="fields"
          :busy="loading"
          sticky-header
          show-empty
          bordered
          class="errors-table"
        >
          <template #table-busy>
            <div class="text-center my-4">
              <eg-b-spinner class="align-middle mr-2"></eg-b-spinner>
              <strong>{{ $t("common.loadingEllipsis") }}</strong>
            </div>
          </template>

          <template #empty>
            <div class="text-center my-4">
              <p>{{ $t("essays.noErrorsToDisplay") }}</p>
            </div>
          </template>

          <template #cell(name)="data">
            <div class="text-truncate" :title="data.value">
              {{ data.value || $t("common.notAvailable") }}
            </div>
          </template>

          <template #cell(fileName)="data">
            <div class="text-truncate" :title="data.value || $t('common.none')">
              {{ data.value || $t("common.none") }}
            </div>
          </template>

          <template #cell(reason)="data">
            <div :title="getReason(data.value)">
              {{ getReason(data.value) }}
            </div>
          </template>
        </eg-b-table>
      </div>
    </div>

    <template #footer="{ close }">
      <eg-button type="secondary" @click="close">{{
        $t("common.close")
      }}</eg-button>
    </template>
  </eg-modal>
</template>

<script>
export default {
  name: "LmsImportErrorsModal",

  props: {
    submissions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fields() {
      return [
        {
          key: "name",
          label: this.$t("common.student"),
          tdClass: "text-truncate",
        },
        {
          key: "fileName",
          label: this.$t("imports.attachment"),
          tdClass: "text-truncate",
        },
        {
          key: "reason",
          label: this.$t("imports.why"),
        },
      ];
    },
  },

  methods: {
    closeModal() {
      this.$egModal.hide("lms-import-errors-modal");
      this.$emit("close");
    },
    onClose() {
      this.$emit("close");
    },
    getReason(reasonCode) {
      const key = `imports.importErrors.${reasonCode}`;
      const translated = this.$t(key);
      return translated !== key
        ? translated
        : this.$t("imports.importErrors.unknown");
    },
  },
};
</script>

<style lang="scss" scoped>
.errors-content {
  p {
    color: var(--color-text-neutral-secondary);
    font-size: var(--typography-font-size-fs-200);
    margin-bottom: 16px;
  }
}

.errors-table-wrapper {
  max-height: 400px;
  overflow-y: auto;
  border-radius: var(--radius-rd-400);
  border: 1px solid var(--color-stroke-neutral-default);

  &::v-deep {
    .errors-table {
      margin-bottom: 0;

      &.table {
        border-collapse: separate;
        border-spacing: 0;
        border: none;
      }

      thead tr th {
        background: var(--color-surface-neutral-container-1, #f6f8fa);
        color: var(--color-text-neutral-secondary);
        font-weight: var(--typography-font-weight-fw-600);
        font-size: var(--typography-font-size-fs-200);
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
        position: sticky;
        top: 0;
        z-index: 1;
        padding: 12px 16px;

        &:first-child {
          border-top-left-radius: var(--radius-rd-400);
        }

        &:last-child {
          border-top-right-radius: var(--radius-rd-400);
        }
      }

      tbody tr {
        td {
          font-size: var(--typography-font-size-fs-200);
          border-left: none;
          border-right: none;
          border-top: none;
          border-bottom: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
          padding: 12px 16px;
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(1) {
            max-width: 200px;
          }

          &:nth-child(2) {
            max-width: 200px;
          }

          &:nth-child(3) {
            max-width: 300px;
            white-space: normal;
          }
        }

        &:last-child td {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
